<template>
	<div
		class="spansImg"
		:class="{
			'spansImg--hasConsole': spans.useConsole,
		}"
	>
		<div class="spansImg__wrapper">
			<span class="spansImg__label spansImg__label--main1">{{
				$t("spanShortLabel", { num: 1 })
			}}</span>
			<span class="spansImg__label spansImg__label--main2">{{
				$t("spanShortLabel", { num: spans.main.length })
			}}</span>

			<template v-if="spans.useConsole">
				<span class="spansImg__label spansImg__label--console1">{{
					$t("consoleShortLabel", { num: 1 })
				}}</span>
				<span class="spansImg__label spansImg__label--console2">{{
					$t("consoleShortLabel", { num: 2 })
				}}</span>
				<img src="./spans--hasConsole.png" alt="Spans" />
			</template>
			<template v-else>
				<img src="./spans--hasntConsole.png" alt="Spans" />
			</template>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		spans: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style scoped>
.spansImg {
	padding-top: 1rem;
}

.spansImg__wrapper {
	position: relative;
}

.spansImg__label {
	position: absolute;
	font-size: 12px;
	font-weight: 600;
	bottom: 100%;
	color: #666;
}

.spansImg__label--main1 {
	left: 21%;
}

.spansImg__label--main2 {
	right: 21%;
}

.spansImg__label--console1 {
	right: 0;
}

.spansImg__label--console2 {
	left: 0;
}
</style>
